import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { keys } from './keys';
import type { SuggestedAction } from '../types/inbox.types';

type Variables = {
  emailId: string;
  suggestedActions: SuggestedAction[];
};

async function updateEmailSuggestedActions(variables: Variables) {
  const { data, error } = await apiClient
    .from('inbox_emails')
    .update({
      suggested_actions: variables.suggestedActions,
      updated_at: new Date().toISOString(),
    })
    .eq('id', variables.emailId)
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
}

export function useUpdateEmailSuggestedActions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEmailSuggestedActions,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.inbox });
    },
  });
}
